import { Component, Input } from '@angular/core'
import { faBell, faDownload, faPowerOff, faUserCircle, faUser } from '@fortawesome/free-solid-svg-icons'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs/internal/Observable'
import { AppState, IAuthState } from '../../../core/reducers'
import { AuthService } from '../../login/services/auth.service'
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons'
import { Router } from '@angular/router'
import { ADMIN_GROUP } from '@sauna-net/dto'
import { getAccessUsers } from '../../access/access-config'
import { NotificationsService } from '../notifications-bell/notifications.service'

@Component({
  selector: 'fs-user-navbar',
  templateUrl: './user-navbar.component.html',
  styleUrls: ['./user-navbar.component.scss'],
})
export class UserNavbarComponent {
  @Input() noName = false
  private readonly undockDragThreshold = 8
  store$: Observable<IAuthState>
  notificationsState$ = this.notifications.state$
  // icons
  faUserCircle = faUserCircle
  faPowerOff = faPowerOff
  faUser = faUser
  faQuestionCircle = faQuestionCircle
  faDownload = faDownload
  faBell = faBell

  constructor(
    public authService: AuthService,
    private store: Store<AppState>,
    private router: Router,
    private notifications: NotificationsService,
  ) {
    this.store$ = this.store.select('auth')
  }

  openNotifications(event: MouseEvent) {
    const trigger = event.currentTarget as HTMLElement | null

    if (!trigger) {
      this.notifications.openPanel()
      return
    }
    this.notifications.toggleMenuPanel(trigger.getBoundingClientRect())
  }

  handleNotificationsMouseDown(event: MouseEvent) {
    if (!event.ctrlKey || event.button !== 0) {
      return
    }

    event.preventDefault()
    event.stopPropagation()

    const startX = event.clientX
    const startY = event.clientY
    let didUndock = false

    const handleMouseMove = (moveEvent: MouseEvent) => {
      if (didUndock) {
        return
      }

      if (Math.hypot(moveEvent.clientX - startX, moveEvent.clientY - startY) < this.undockDragThreshold) {
        return
      }

      didUndock = true
      this.notifications.setBellDockedToUserMenu(false)
      this.notifications.openPanelFromBell()
    }

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
  }

  openChangelogs() {
    void this.router.navigate(['/changelogs'])
  }

  get isAndroid(): boolean {
    return /(android)/i.test(navigator.userAgent)
  }

  canDownloadSaunaClub(auth?: IAuthState | null): boolean {
    const user = auth?.user
    if (!user) return false
    const allowedUsers = getAccessUsers('saunaClubDownloadUsers')
    return allowedUsers.includes(user.user_id ?? -1) || !!user.groups?.some(g => g.id === ADMIN_GROUP)
  }

  logOut() {
    this.authService.logOut()
  }
}
